
import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Renderer } from '@df/ng/renderer';
import { UseService } from '@df/util/service/use.service';

@Injectable({
    providedIn: 'root'
})
export class BodyClassService {
    private existingSubscriptions: string[] = [];

    /**
     * Service dependencies
     */
    constructor(private useService: UseService, private renderer: Renderer, @Inject(DOCUMENT) private document: Document) {}

    /**
     * Add or remove depending on value passed
     */
    set(className: string | string[], source: any, value: boolean) {
        value ? this.add(className, source) : this.remove(className, source);
    }

    /**
     * Register usage
     */
    add(classNames: string | string[], source: any) {
        (Array.isArray(classNames) ? classNames : [classNames]).forEach(className => {
            if (!this.existingSubscriptions.includes(className)) {
                this.useService.get(this.getLockName(className)).subscribe((status: boolean) => {
                    this.renderer.setClass(this.document.body, className, status);
                    // set the same class name to document root, but with suffix `*-root`
                    if (className) {
                        this.renderer.setClass(this.document.documentElement, `${className}-root`, status);
                    }
                });
            }
            this.useService.lock(this.getLockName(className), source);
        });
    }

    /**
     * Unregister usage
     */
    remove(classNames: string | string[], source: any) {
        (Array.isArray(classNames) ? classNames : [classNames]).forEach(className => {
            this.useService.unlock(this.getLockName(className), source);
        });
    }

    /**
     * className to lock key
     */
    getLockName(className: string): string {
        return 'bodyClass.' + className;
    }
}
